import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/landing.png'


const _hoisted_1 = { class: "flex flex-col md:flex-row p-4 bg-gray" }
const _hoisted_2 = { class: "w-full md:w-1/2 flex flex-col justify-center items-center" }
const _hoisted_3 = { class: "max-w-md mx-auto mt-10 space-y-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-5xl md:text-6xl font-bold font-robot text-pop-up-top" }, " Blogger, ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-5xl md:text-6xl font-bold font-robot relative -top-4 text-pop-up-top" }, "Web Developer", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "w-96 text-justify text-lg leading-8" }, "I am a full-stack web developer based in Nairobi. I love building and working on diverse distributed teams.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { class: "w-full md:w-48 btns border-2 border-black py-2 hover:text-white font-bold hover:bg-primaryColor hover:scale-[1.1] ease-out duration-300" }, "Portfolio", -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div id=\"social-icons\" class=\"w-full md:w-96 flex justify-center space-x-10 mt-28 md:relative md:right-5 md:justify-start\"><a href=\"https://linkedin.com/in/ian-mugenya\" target=\"_blank\"><i class=\"fa-brands fa-linkedin text-3xl md:text-2xl hover:text-primaryColor hover:scale-[1.1] ease-out duration-300\"></i></a><a href=\"https://twitter.com/McBooll\" target=\"_blank\"><i class=\"fa-brands fa-twitter text-3xl md:text-2xl hover:text-primaryColor hover:scale-[1.1] ease-out duration-300\"></i></a><a href=\"#\" target=\"_blank\"><i class=\"fa-brands fa-github text-3xl md:text-2xl hover:text-primaryColor hover:scale-[1.1] ease-out duration-300\"></i></a><a href=\"https://medium.com/@ianmugenya\" target=\"_blank\"><i class=\"fa-brands fa-medium text-3xl md:text-2xl hover:text-primaryColor hover:scale-[1.1] ease-out duration-300\"></i></a><a href=\"https://dev.to/ianmcbull\" target=\"_blank\"><i class=\"fa-brands fa-dev text-3xl md:text-2xl hover:text-primaryColor hover:scale-[1.1] ease-out duration-300\"></i></a></div>", 1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/2 mt-4 md:mt-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Landing page image",
    class: "md:w-3/4"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_router_link, {
          to: {name:'blogs.vue'},
          class: "block",
          id: "portfolio-btn"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _hoisted_8
    ]),
    _hoisted_9
  ]))
}